import { Navigate } from 'react-router-dom'

export default function AuthRoute({ children }) {
  const token = sessionStorage.getItem('adminToken')
  if (!token) return <Navigate to="/login" replace />
  return children
}
